import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Gibt die aktuelle Rolle des Nutzers aus dem ID-Token-Custom-Claim zurück.
 * Kein extra API-Call — die Rolle steckt im JWT.
 *
 * @returns {{ rolle: "user"|"admin"|null, laden: boolean }}
 */
export function useRolle() {
  const [rolle, setRolle] = useState(null);
  const [laden, setLaden] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setRolle(null);
        setLaden(false);
        return;
      }
      try {
        // forceRefresh=false: gecachten Token verwenden (enthält Custom Claims)
        const tokenResult = await user.getIdTokenResult(false);
        setRolle(tokenResult.claims.role || 'user');
      } catch {
        setRolle('user');
      } finally {
        setLaden(false);
      }
    });
  }, []);

  return { rolle, laden };
}

/**
 * Erzwingt einen Token-Refresh und liest die Rolle neu.
 * Aufrufen nachdem das Backend einen neuen Custom Claim gesetzt hat.
 *
 * @returns {Promise<string|null>} Neue Rolle oder null
 */
export async function rolleAktualisieren() {
  const user = auth.currentUser;
  if (!user) return null;
  const tokenResult = await user.getIdTokenResult(true);
  return tokenResult.claims.role || 'user';
}
